import {bootstrapFullApp} from "./bootstrap-full-app";

bootstrapFullApp(document.getElementById('root'));
